import _ from 'lodash'
import Cookies from 'js-cookie'
import queryString from 'query-string'
import Config from '../configs'
import fetcher from '../lib/fetcher'
import moment from 'moment'
// import I18n from '../lib/i18n'

const cookieName = '__om_counter_display_session'
const API = new fetcher(Config.get('API_URL'))
const useAuthConfig = !_.isEmpty(Config.get('API_KEY')) && !_.isEmpty(Config.get('API_SECRET'))

const _currentLocale = () => {
  // return I18n.currentLocale() || I18n.defaultLocale
  return 'en'
}

export function getAuthToken() {
  return {
    'x-access-key': useAuthConfig ? Config.get('API_KEY') : Cookies.get(`${cookieName}__x-access-key`),
    'x-secret-key': useAuthConfig ? Config.get('API_SECRET') : Cookies.get(`${cookieName}__x-secret-key`),
    'x-internal-request': 1
  }
}
export function removeAuthToken() {
  if (useAuthConfig) {
    // nothing to remove
  } else {
    Cookies.remove(`${cookieName}__x-access-key`)
    Cookies.remove(`${cookieName}__x-secret-key`)
  }
}

export function hasCredential() {
  return useAuthConfig
    ? true
    : !_.isEmpty(Cookies.get(`${cookieName}__x-access-key`))
}

export function authorise(provision_code) {
  return API.post(`/api/v2/${_currentLocale()}/ticket_take_away_hkd/internal_apps/provision?includes=active_id_secret_pair,hardware,hardwares.store`, {
    schema_version: '2022-06-24',
    data: {
    	internal_app: {
        provision_code
    	}
    }
  }, {
    'x-internal-request': 1,
  }).then( (response) => {
    return response.data
  })
}

export function setAuthToken(app_id, app_secret) {
  if (useAuthConfig) {
    // nothing to set
  } else {
    Cookies.set(`${cookieName}__x-access-key`, app_id, {expires: 365})
    Cookies.set(`${cookieName}__x-secret-key`, app_secret, {expires: 365})
  }
}

export function getShipments() {
  const order_confirmed_date = Config.get('ORDER_CONFIRMED_DATE') || moment().format('DD-MM-YYYY')
  const params = queryString.stringify({
    schema_version: '2022-06-24',
    delivery_types: ['collect_at_store'],
    state: 'ready_to_receive',
    store_code_eq: Config.get('STORE_CODE') || localStorage.getItem('storeCode'),
    order_confirmed_date,
    order_state: 'confirmed',
    page_size: 31,
    sort_by: 'ready_to_receive_at_desc'
  }, {arrayFormat: 'bracket'})
  const header = getAuthToken()
  return API.get(`/api/v2/${_currentLocale()}/ticket_take_away_hkd/shipments?${params}`, header)
}



export function handleError(err) {
  console.log('API.handleError::raw', err)
  let error_message = {}
  let inline_errors = {}

  if (err instanceof TypeError) {
    // TypeError so should not show to user, simply return a generic message
    // and log the issue.
    // error_message = I18n.t('errors.500')
    error_message = "Error 500"
    // TODO: send to rollbar
  } else if (_.isArray(err.errors)) {
    err.errors.forEach((error) => {
      const { message, type } = error
      switch (type) {
        case 'general':
          error_message = message
          break
        case 'validation_failed':
          error_message = message
          Object.keys(error.data).forEach((key) => {
            let arr = _.get(error, `data[${key}]`)
            if (!_.isArray(arr)) {
              arr = [arr]
            }
            _.forEach(arr, (obj, index) => {
              _.forEach(_.get(obj, 'errors', {}), (v, k) => {
                let msg = _.get(v, 'full_message[0]') || _.get(v, '[0]') || v.toString()
                _.set(inline_errors, `${key}[${index}].${k}`, msg)
              })
            })
          })
          break
        default:
          break
      }
    })
  } else {
    // Likely a server failure so simply return a generic message and log the issue.
    // error_message = I18n.t('errors.500')
    error_message = "Error 500"
    // TODO: send to rollbar
  }

  return _.pickBy({
    ..._.pick(err, ['status', 'code']),
    error_message,
    inline_errors
  }, _.identity)
}



// WEBPACK FOOTER //
// ./src/api/index.js